import { useEffect, useContext } from "react";
import { handleEMenu, handlePagination, handleSort } from "./utils";
import { UtagContext } from "../../context/UtagContext";

export const useUpdateAttributeByQuery = () => {
  const utagContext = useContext(UtagContext);
  //Update ref event for table sort,filter and paging
  useEffect(() => {
    let sortIconDefault = document.querySelectorAll(
      '.ag-header-cell-label'
    );
    let filterMenu = document.querySelectorAll(
      '.ag-header-icon.ag-header-cell-menu-button.ag-header-menu-always-show'
    );
    let pagingButton = document.querySelectorAll('.ag-paging-button');

    try {
      if (sortIconDefault && sortIconDefault.length > 0) {
        for (let i = 0; i < sortIconDefault.length; i++) {
          sortIconDefault[i].setAttribute('ref_page_event', 'Sort Table');
          sortIconDefault[i].addEventListener('click', () => handleSort(utagContext));
        }
      }

      if (filterMenu && filterMenu.length > 0) {
        for (let i = 0; i < filterMenu.length; i++) {
          filterMenu[i].setAttribute('ref_page_event', 'Filter Column');
          filterMenu[i].addEventListener('click', () => handleEMenu(utagContext));
        }
      }
      if (pagingButton && pagingButton.length > 0) {
        for (let i = 0; i < pagingButton.length; i++) {
          pagingButton[i].setAttribute(
            'ref_page_event',
            'Change Page in Search Results'
          );
          pagingButton[i].addEventListener('click', () => handlePagination(utagContext));
        }
      }
    } catch {
    }
  });
}
